import boards from './boards';
import boardSteps from './boardSteps';
import tasks from './tasks';

export default {
  namespaced: true,
  modules: {
    boards,
    boardSteps,
    tasks,
  },
};
